const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

export const isValidCPF = (cpf: string): boolean => {
  // TODO - Implment Complete validation
  return cpf.length === CPF_LENGTH;
};

export const isValidCNPJ = (cnpj: string): boolean => {
  // TODO - Implment Complete validation
  return cnpj.length === CNPJ_LENGTH;
};